export default {
  MALE: "male",
  FEMALE: "female",
}